import React from 'react';
import {isEmpty} from "lodash";
import FooterInfo from '../components/app/FooterInfo/FooterInfo';
import Heading from "../components/app/Heading/Heading";
import OmronPagingInfo from '../components/app/PagingInfo/PagingInfo';
import OmronResults from '../components/app/Results/Results';
import OmronSearchBox from '../components/app/SearchBox/SearchBox';
// import OmronSearchBox from '../components/app/SearchBox/SelecctCategoryComponent.bkp';
import OmronPagination from '../components/app/Pagination/Pagination';
import AppLayoutWrapper from './AppLayoutWrapper';
import OmronDoubtFacet from '../components/app/Facets/DoubtsFacet';
import OmronProductFacet from '../components/app/Facets/ProductsFacet';
import queryString from '../../helpers/queryString';

const AppLayout = ({setSearchTerm, addFilter}) => {
  React.useEffect(() => {
    const search = queryString.parse(window.location.search);
    if (!isEmpty(search)) {
      const {filters, q} = search;
      if (q) {
        setSearchTerm(q);
      }
      if (filters && filters.length > 0) {
        filters.forEach(({field, values, type}) => addFilter(field, values, type));
      }
    }
  }, []);
  return (
    <AppLayoutWrapper>
      <div className="l-main">
        <div>
          <Heading />
          <OmronSearchBox />
          <OmronPagingInfo />
          <OmronResults />
          <OmronPagination />
        </div>
        <FooterInfo />
      </div>
        <div className="l-aside">
          <OmronProductFacet />
          <OmronDoubtFacet />
        </div>
    </AppLayoutWrapper>
  );
};

export default AppLayout;
